import React from "react";

export const StakingSection = () => {
  return (
    <section className="w-full py-20 px-4 bg-transparent">
      <div className="flex flex-col lg:flex-row max-w-[1342.98px] mx-auto items-center justify-between gap-10">
        {/* Left Text Section */}
        <div className="w-full lg:w-[662.93px]">
          <h2 className="text-5xl font-bold text-white leading-[56px] max-sm:text-4xl max-sm:leading-10 font-fredoka mb-8">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF]">
              HOW IT WORKS
            </span>
          </h2>

          <div className="flex flex-col gap-8">
            <div className="flex items-center gap-2.5">
              <div className="w-8 h-8 rounded-2xl">
                <div className="w-4 h-4 top-2 left-2 bg-[#473256] rounded-lg relative" />
              </div>
              <p className="text-2xl font-medium text-transparent bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF] bg-clip-text">
                STAKING IS LIVE DURING THE PRESALE
              </p>
            </div>

            <p className="text-[22px] font-semibold text-neutral-100 leading-8">
              As soon as you purchase CHARLIE tokens, you can lock them to start
              earning rewards
            </p>

            <p className="text-2xl font-semibold text-neutral-100">
              Benefits of Early Staking:
            </p>

            {/* Benefits List */}
            <div className="flex flex-col gap-3 relative">
              <img
                className="absolute w-px h-[122px] top-3.5 left-1.5"
                alt="Line"
                src="https://c.animaapp.com/mcbwf696ne6LZr/img/line-1-1.svg"
              />

              {[
                "Priority APR rates for early stakers",
                "Bonus rewards for presale stakers (extra pNFTs / boosted APR)",
                "Stake without waiting for TGE",
              ].map((text, idx) => (
                <div key={idx} className="flex gap-4">
                  <div className="pt-[9px]">
                    <div className="w-3 h-3 rounded-md bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF]" />
                  </div>
                  <p className="text-[22px] font-medium text-neutral-100 leading-8">
                    {text}
                  </p>
                </div>
              ))}
            </div>

            <p className="text-[22px] text-neutral-100 leading-8">
              APR may be adjusted dynamically to balance supply
            </p>

            <p className="text-2xl font-semibold text-neutral-100">
              Staking Rewards Source:
            </p>

            {/* Rewards Source List */}
            <div className="flex flex-col gap-3 relative">
              <img
                className="absolute w-px h-11 top-3.5 left-1.5"
                alt="Line"
                src="https://c.animaapp.com/mcbwf696ne6LZr/img/line-1.svg"
              />

              <div className="flex gap-4">
                <div className="pt-[9px]">
                  <div className="w-3 h-3 rounded-md bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF]" />
                </div>
                <p className="text-[22px] font-medium text-neutral-100 leading-8">
                  From a dedicated 150M CHARLIE pool (15% of total supply)
                </p>
              </div>

              <div className="flex gap-4">
                <div className="pt-[9px]">
                  <div className="w-3 h-3 rounded-md bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF]" />
                </div>
                <p className="text-[22px] text-neutral-100 leading-8">
                  <span className="font-bold">Staked tokens are locked</span>
                  <span className="font-medium">
                    {" "}
                    – not tradable until unlocked, reducing sell pressure
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Image Section */}
        <div className="w-full max-w-[601px] relative flex justify-center items-center">
          <div className="w-full flex justify-center px-4 max-md:mt-10">
            <img
              className="max-w-[531px] w-full h-auto object-contain"
              alt="Group70"
              src="Group70.png"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
